import script from "./FooterMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterMain.vue?vue&type=script&lang=ts&setup=true"

import "./FooterMain.vue?vue&type=style&index=0&id=52b06b92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b06b92"]])

export default __exports__